import LaporanSuratJalan from "./LaporanSuratJalan";

export default LaporanSuratJalan;
